export const AclsEnum = {
  CAN_ACCESS_DEALER_DASHBOARD: 'can_access_xdealer_dashboard',
  CAN_EXPORT_CUSTOMERS: 'can_export_customers',
  CAN_EXTEND_DGFE_INITIALIZATIONS: 'can_extend_dgfe_initializations',
  CAN_FULL_DATA_EXPORT_DEVICES: 'can_full_data_export_devices',
  CAN_ACCESS_XDEALER_DEVICE_DIAGNOSTICS: 'can_access_xdealer_device_diagnostics',
  CAN_VIEW_ANY_USERS: 'can_view_any_users',
  CAN_SIGN_APPALTO: 'can_sign_appalto',
}
